import { motion } from "framer-motion";

export default function SystemFlow({ nodes, label, testId }) {
  return (
    <div data-testid={testId} className="group">
      {label && (
        <p className="font-mono text-[10px] tracking-[0.3em] text-neutral-500 mb-4 uppercase">{label}</p>
      )}
      <div className="flex flex-wrap items-center gap-y-4">
        {nodes.map((node, i) => (
          <div key={node} className="flex items-center flex-1 min-w-fit last:flex-none">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="border border-white/15 bg-[#0A0A0A] px-4 py-2.5 font-mono text-[10px] md:text-[11px] tracking-[0.2em] text-neutral-300 uppercase whitespace-nowrap group-hover:border-cyan/40 transition-colors duration-500"
            >
              {node}
            </motion.div>
            {i < nodes.length - 1 && (
              <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12 + 0.15, ease: "easeOut" }}
                className="origin-left flex-1 min-w-[24px] h-px beam-line animate-beam mx-1"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
